import React, { useEffect, useState } from "react";
import { Avatar, Button, Input, message, Popover } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { changeUserPassword, showAuthLoader, userSignOut } from "../../appRedux/actions/Auth";
import { useHistory } from "react-router";
import CircularProgress from "../../components/CircularProgress/index";
import Modal from "antd/lib/modal/Modal";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
const UserProfile = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const signOut = (e) => {
    e.stopPropagation();
    dispatch(userSignOut());
  }
  const {
    loader,
    token,
    alertMessage,
    showMessage,
  } = useSelector(({ auth }) => {
    return auth;
  });
  const [showModal, setShowModal] = useState(false);
  const onFinishRecovert = (e) => {
    dispatch(showAuthLoader());
    dispatch(changeUserPassword(e));
  }
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  }
  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li><span onClick={(e) => setShowModal((prev) => { return !prev; })}>تنظیمات حساب</span></li>
      <li><span onClick={(e) => signOut(e)}>خروج</span></li>
    </ul>
  );

  useEffect(() => {
    if (token === null) {
      history.push("/signIn");
    }
  }, [token]);

  const { contact } = useSelector(({ contact }) => contact);
  return loader ? <div className="gx-loader-view">
    <CircularProgress />
  </div> : (

    <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
      <Popover placement="bottomRight" content={userMenuOptions} >
        <Avatar className="gx-size-40 gx-pointer gx-mr-3">
          {contact?.userName?.charAt(0).toUpperCase()}</Avatar>
        {/* <Avatar src='https://via.placeholder.com/150x150'
          className="gx-size-40 gx-pointer gx-mr-3" alt="" /> */}
        <span className="gx-avatar-name">{contact?.userName}<i
          className="icon icon-chevron-down gx-fs-xxs gx-ml-2" /></span>
      </Popover>
      <Modal
        visible={showModal}
        footer={null}
        onCancel={(e) => { setShowModal(false); }}
      >
        <div className="gx-mt-5">
          <Form
            name="basic"
            onFinish={onFinishRecovert}
            onFinishFailed={onFinishFailed}
            className="gx-signin-form gx-form-row0"
          >
                      {"در این قسمت میتوانید کلمه عبور خود را تغییر دهید"}
            <FormItem
              rules={[
                {
                  required: true,
                  message: "کلمه عبور را وارد کنید",
                },
              ]}
              name="Password"
            >
              <Input type='password' placeholder="کلمه عبور" />
            </FormItem>

            <FormItem>
              <Button type="primary" className="gx-mb-0" htmlType="submit">
                تغییر رمز
              </Button>
            </FormItem>
          </Form>
          {loader ? (
            <div className="gx-loader-view">
              <CircularProgress />
            </div>
          ) : null}
        </div>
      </Modal>
    </div>

  )
};

export default UserProfile;
